import { render, staticRenderFns } from "./service-course-drawer.vue?vue&type=template&id=80cc2ac2&scoped=true"
import script from "./service-course-drawer.vue?vue&type=script&lang=js"
export * from "./service-course-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cc2ac2",
  null
  
)

export default component.exports